<template>
  <div :class="$style.promo">
    <div :class="$style.promoValue">
      {{ code }}
      <div :class="$style.promoType">Promocode</div>
    </div>

    <div :class="$style.divider"></div>

    <div :class="$style.promoCaption">
      {{ caption }}
    </div>

    <div :class="$style.divider"></div>

    <div :class="$style.promoCircle">
      {{ value }}
      <div :class="$style.promoCircleCaption">
        {{ type }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PartnersPromoParams } from './index.js';

defineProps<PartnersPromoParams>();
</script>

<style lang="scss" module>
  .promo {
    display: flex;
    align-items: center;
    gap: 34px;
    margin-top: 10px;
    padding: 29px 42px;
    border-radius: 24px;
    background: #FBFCFF;
    text-align: center;

    @media (max-width: 1023px) {
      flex-wrap: wrap;
      padding: 28px 28px 38px 28px;
      justify-content: space-between;
    }

    &Circle {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      width: 103px;
      height: 103px;
      background-color: #293EFF;
      border-radius: 103px;
      font-size: 32px;
      color: #fff;

      @media (max-width: 1023px) {
        order: 3;
        font-size: 24px;
        width: 92px;
        height: 92px;
      }

      &Caption {
        font-size: 12px;
      }
    }

    &Value {
      color: #293EFF;
      font-size: 32px;

      @media (max-width: 1023px) {
        order: 1;
        font-size: 24px;
        text-align: left;
      }
    }

    &Type {
      margin-top: 8px;
      font-size: initial;

      @media (max-width: 1023px) {
        font-size: 12px;
        margin-top: 4px;
      }
    }

    &Caption {
      color: #71787F;

      @media (max-width: 1023px) {
        order: 4;
        width: 100%;
        text-align: left;
      }
    }
  }

  .divider {
    width: 1px;
    height: 56px;
    background: #293EFF;

    @media (max-width: 1023px) {
      order: 2;

      &:nth-child(2) {
        display: none;
      }
    }
  }
</style>